import React, { useState, useEffect } from 'react';
import Loader from "react-loader-spinner";
import { FiEdit2 } from "react-icons/fi";
import { MdDelete } from 'react-icons/md';
import { useTranslation } from "react-i18next";

import * as processCosts from '../../Redux/Actions/processCost';
import { getParams } from '../../utils';
import { toastMessage } from '../../utils/toast';
import { errorHandler } from '../../utils/initiate';
import DropDown from '../Ui/DropDown';
import ChildProcessCostModal from './childProcessCostModal';

const UpdateProcessCost = ({ history }) => {

    let params = getParams(window.location.search);
    
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState('');
    const [addedData, setAddedData] = useState([]);
    const [attributeID, setAttributeID] = useState(null);
    const [attributeName, setAttributeName] = useState('');
    const [moduleTypeOptions, setModuleTypeOptions] = useState([]);
    const [moduleGroupOptions, setModuleGroupOptions] = useState([]);
    const [moduleType, setModuleType] = useState('');
    const [moduleGroup, setModuleGroup] = useState('');
    const [costAmount, setCostAmount] = useState(0);
    const [sla, setSla] = useState(0);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [processCostID, setProcessCostID] = useState('');
    const [showChildProcessCostModal, setShowChildProcessCostModal] = useState(false);
    const [childData, setChildData] = useState({});
    const { t } = useTranslation();

    useEffect(() => {
        setLoading(true);
        setChildData({});
        processCosts.getIndividual(params.processCostID).then(res => {
            if(res && res.data) {
                setName(res.data.name);
                handleCheckCPCAvailable(res.data.processCostDetails);
                handleModuleTypesAndGroups();
                setLoading(false);
            }
        }).catch(err => {
            setLoading(false);
            toastMessage('error', `Unable to get the process cost info`);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleCheckCPCAvailable = (data) => {
        let cPCAvailableData = data;
        cPCAvailableData = cPCAvailableData.map(cPC => cPC.childProcessCostDetails === null ? {
            childProcessCostDetails: [], attributeName: cPC.attributeName, costAmount: cPC.costAmount, sla: cPC.sla, id: cPC.id, moduleGroupId: cPC.moduleGroupId, moduleGroupName: cPC.moduleGroupName, moduleType: cPC.moduleType
        } : cPC);
        setAddedData(cPCAvailableData);
    };

    const handleModuleTypesAndGroups = () => {
        setLoading(true);
        processCosts.getModuleTypeAndGroups().then(res => {
            if(res && res.data) {
                let moduleTypeData = res.data.moduleTypes && res.data.moduleTypes.map(({key, value}) => ({label: key, value}));
                let moduleGroupData = res.data.moduleGroups && res.data.moduleGroups.map(({id, name}) => ({label: name, value: id}));
                setModuleTypeOptions(moduleTypeData);
                setModuleGroupOptions(moduleGroupData);
                setLoading(false);
            }else{
                setLoading(false);
                toastMessage('error', 'Unable to load the module types and groups');
            }
        }).catch(err => {
            errorHandler(err);
        });
    };

    const handleAddProcessCostData = () => {
        let newData = addedData;
        newData.push({ id: null, attributeName, costAmount, sla, moduleType: moduleType.value, moduleGroupId: moduleGroup.value, moduleGroupName: moduleGroup.label, childProcessCostDetails: [] });
        setAttributeName(''); setCostAmount(0); setSla(0); setModuleType(''); setModuleGroup('');
    };

    const handleAddChildProcessCostData = (cAttributeName, cCostAmount, cModuleType, cModuleGroup, childID) => {
        let newData = addedData;
        if (childID) {
            newData.map((pc, index) => {
                return (
                    (index+1 === processCostID) ? 
                        pc.childProcessCostDetails = pc.childProcessCostDetails.map((cPC, index) => {
                            let childPCId = index+1;
                            return (
                                (childID === childPCId) ? 
                                    { id: cPC.id, attributeName: cAttributeName, costAmount: cCostAmount, moduleType: cModuleType.value, moduleGroupId: cModuleGroup.value, moduleGroupName: cModuleGroup.label }
                                    : cPC
                            )
                        })
                    : pc
            )});
        } else {
            newData.map((pc, index) => {
                return (
                    (index+1 === processCostID) ? 
                        pc.childProcessCostDetails.push({ id: null, attributeName: cAttributeName, costAmount: cCostAmount, moduleType: cModuleType.value, moduleGroupId: cModuleGroup.value, moduleGroupName: cModuleGroup.label })
                    : pc
            )});
        }
        setAddedData(newData);
        setShowChildProcessCostModal(false);
    };

    const handleUpdateProcessCostData = () => {
        let updatedData = [...addedData];
        let objIndex = updatedData.findIndex((obj) => obj.id === attributeID);
        updatedData[objIndex].attributeName = attributeName;
        updatedData[objIndex].costAmount = costAmount;
        updatedData[objIndex].sla = sla;
        updatedData[objIndex].moduleType = moduleType.value;
        updatedData[objIndex].moduleGroupId = moduleGroup.value;
        updatedData[objIndex].moduleGroupName = moduleGroup.label;
        setAddedData(updatedData);
        setAttributeID(null); setAttributeName(''); setCostAmount(0); setSla(0); setModuleType(''); setModuleGroup('');
    };

    const handleDeleteProcessCostData = (ID) => {
        let newData = addedData;
        newData = newData.filter((processCost, index) => ID !== index+1);
        setAddedData(newData);
    };

    const handleChildDeleteProcessCostData = (parentProcessCostID, childProcessCostID) => {
        let newData = addedData;
        newData = newData.map((parent, index) => {
            let filtered = parent.childProcessCostDetails.filter((child, index) => (childProcessCostID !== index+1));
            return (
                (parentProcessCostID === parent.id) ? {id: parent.id, childProcessCostDetails: filtered, attributeName: parent.attributeName, costAmount: parent.costAmount, moduleGroup: parent.moduleGroup, moduleGroupId: parent.moduleGroupId, moduleType: parent.moduleType}
                : parent
        )});
        setAddedData(newData);
    };

    const handleProcessCostData = () => {
        setButtonLoading(true);
        let payload = {
            id: params.processCostID,
            name,
            processCostDetails: addedData
        };
        processCosts.update(payload).then(res => {
            if(res && res.data){
                toastMessage('success', `Process cost details ${params.processCostID ? 'updated' : 'added'} successfully`);
                setName(''); setAttributeName(''); setCostAmount(0); setModuleType(''); setModuleGroup('');
                history.push(`/master/process-cost/manage`);
            }else{
                toastMessage('error', 'Process cost details added failed');
            }
            setButtonLoading(false);
        });
    };

    const handleDisableAddCTA = () => {
        return buttonLoading || (name === '') || (attributeName === '') || !(moduleType.value === 'AAMER_ENTITY' ? costAmount >= 0 : costAmount > 0) || (moduleType.length === 0) || (moduleGroup.length === 0);
    };

    return (
        <>
            <div className="container-fluid">
                <div className="my-4">
                    <span className="card-label font-weight-bolder c-pointer" onClick={() => history.push(`/master/process-cost/manage`)}>{t("mastersManagement.processCost.manageProcessCosts")}</span>
                    <span className="card-label font-weight-bolder mx-2">/</span>
                    <span className="card-label font-weight-bolder text-dark">{name}</span>
                </div>
                {loading ? <Loader type="ThreeDots" color="#ad1a5f" height={40} width={40} style={{textAlign: 'center', marginBottom: '50px'}} />
                    : <div>
                    <div className="card-body pt-0 pb-3">
                        <div className="form-group fv-plugins-icon-container">
                            <label className="mb-1">{t("mastersManagement.processCost.name")}</label>
                            <input placeholder={t("mastersManagement.processCost.namePlaceholder")} type="text" className="form-control" name="name" value={name} onChange={e => setName(e.target.value)} />
                        </div>
                        <div className="form-group fv-plugins-icon-container">
                            <label className="mb-1">{t("mastersManagement.processCost.attributeName")}</label>
                            <input placeholder={t("mastersManagement.processCost.attributeNamePlaceholder")} type="text" className="form-control"
                                name="Attribute Name" value={attributeName} onChange={e => setAttributeName(e.target.value)} />
                        </div>
                        <div className="form-group fv-plugins-icon-container">
                            <label className="mb-1">{t("mastersManagement.processCost.costAmount")}</label>
                            <input placeholder={t("mastersManagement.processCost.costAmountPlaceholder")} type="number" className="form-control"
                                name="Cost Amount" value={costAmount} onChange={e => setCostAmount(e.target.value)} />
                        </div>
                        <DropDown label={t("mastersManagement.processCost.moduleType")} placeholder={t("mastersManagement.processCost.moduleTypePlaceholder")} options={moduleTypeOptions} value={moduleType} onChange={(value) => setModuleType(value)} />
                        <DropDown label={t("mastersManagement.processCost.moduleGroup")} placeholder={t("mastersManagement.processCost.moduleGroupPlaceholder")} options={moduleGroupOptions} value={moduleGroup} onChange={(value) => setModuleGroup(value)} />
                        <div className="form-group fv-plugins-icon-container">
                            <label className="mb-1">{t("mastersManagement.processCost.sla")}</label>
                            <input placeholder={t("mastersManagement.processCost.slaPlaceholder")} type="number" className="form-control"
                                name="SLA" value={sla} onChange={e => setSla(e.target.value)} />
                        </div>
                        <button disabled={handleDisableAddCTA()} onClick={() => {attributeID ? handleUpdateProcessCostData() : handleAddProcessCostData()}} type="button" className="btn btn-primary font-weight-bold mb-4">{attributeID ? t("mastersManagement.manage.update") : t("mastersManagement.add.add")}</button>
                        {(addedData.length !== 0) && <>
                            <div className="d-flex flex-column">
                                {addedData.map(({ id, attributeName, costAmount, sla, moduleType, moduleGroupId, moduleGroupName, childProcessCostDetails }, index) =>  {
                                    let parentProcessCostID = index+1;
                                    return (
                                        <div className="mb-2" key={parentProcessCostID}>
                                            <div className="d-flex align-items-start mb-1">
                                                <p className="me-2">{parentProcessCostID}.</p>
                                                <div className="me-3">
                                                    <p>{t("mastersManagement.processCost.attributeName")}: {attributeName}</p>
                                                    <p>{t("mastersManagement.processCost.costAmount")}: {costAmount}</p>
                                                    <p>{t("mastersManagement.processCost.moduleType")}: {moduleType}</p>
                                                    <p>{t("mastersManagement.processCost.moduleGroup")}: {moduleGroupName}</p>
                                                    <p>{t("mastersManagement.processCost.sla")}: {sla}</p>
                                                    {(childProcessCostDetails && childProcessCostDetails.length !== 0) && <div className="mt-2 ms-4">
                                                        <p className="text-muted">{t("mastersManagement.processCost.childProcessCostTitle")}</p>
                                                        {childProcessCostDetails.map(({ attributeName: cAN, costAmount: cCA, moduleType: cMT, moduleGroupId: cMGId, moduleGroupName: cMG }, index) => {
                                                            let childProcessCostID = index+1;
                                                            return (
                                                                <div className="d-flex" key={childProcessCostID}>
                                                                    <div key={childProcessCostID} className="d-flex align-items-start mb-1 me-3">
                                                                        <p className="me-2">{childProcessCostID}.</p>
                                                                        <div>
                                                                            <p>{t("mastersManagement.processCost.attributeName")}: {cAN}</p>
                                                                            <p>{t("mastersManagement.processCost.costAmount")}: {cCA}</p>
                                                                            <p>{t("mastersManagement.processCost.moduleType")}: {cMT}</p>
                                                                            <p>{t("mastersManagement.processCost.moduleGroup")}: {cMG}</p>
                                                                        </div>
                                                                    </div>
                                                                    <FiEdit2 className="c-pointer font-16" onClick={() => {
                                                                        setChildData({
                                                                            id: childProcessCostID, costAmount: cCA, attributeName: cAN,
                                                                            moduleGroup: {label: cMG, value: cMGId}, moduleType: {label: cMT, value: cMT}
                                                                        });
                                                                        setShowChildProcessCostModal(true); setProcessCostID(parentProcessCostID);
                                                                    }} />
                                                                    <MdDelete className="c-pointer ms-2 font-20" onClick={() => handleChildDeleteProcessCostData(id, childProcessCostID)} />
                                                                </div>
                                                            )}
                                                        )}
                                                    </div>}
                                                </div>
                                                <button onClick={() => {setShowChildProcessCostModal(true); setProcessCostID(parentProcessCostID); setChildData({});}} type="button" className="btn btn-primary font-weight-bold font-12 me-4">
                                                    {t("mastersManagement.processCost.addChildProcessCost")}
                                                </button>
                                                <FiEdit2 className="c-pointer font-16" onClick={() => {
                                                    setAttributeID(id); setAttributeName(attributeName); setModuleType({label: moduleType, value: moduleType}); 
                                                    setModuleGroup({label: moduleGroupName, value: moduleGroupId}); setCostAmount(costAmount); setSla(sla);
                                                }} />
                                                <MdDelete className="c-pointer font-18 mx-2" onClick={() => handleDeleteProcessCostData(parentProcessCostID)} />
                                            </div>
                                        </div>
                                    )}
                                )}
                            </div>
                            <button disabled={buttonLoading} onClick={handleProcessCostData} type="button" className="d-flex align-items-center btn btn-primary font-weight-bold mb-3">
                                {t("mastersManagement.processCost.submit")} {buttonLoading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                            </button>
                        </>}
                    </div>
                    {showChildProcessCostModal && <ChildProcessCostModal t={t} type={(childData && childData.id) ? "edit" : "add"} childData={childData} showModal={showChildProcessCostModal} moduleTypeOptions={moduleTypeOptions} moduleGroupOptions={moduleGroupOptions} handleOk={handleAddChildProcessCostData} handleCancel={() => setShowChildProcessCostModal(false)} />}
                </div>}
            </div>
        </>
    );
};

export default UpdateProcessCost;